import { render, staticRenderFns } from "./multipleDialog.vue?vue&type=template&id=5e20c490"
import script from "./multipleDialog.vue?vue&type=script&lang=js"
export * from "./multipleDialog.vue?vue&type=script&lang=js"
import style0 from "./multipleDialog.vue?vue&type=style&index=0&id=5e20c490&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports